import * as React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Iprops {
    /** Button label. Casing is handled by the global .btn styling (Title Case). */
    label: string;
    onClick: (event?: any) => void;
    disabled?: boolean;
    /** react-bootstrap bsStyle; defaults to the solid-blue "primary" button. */
    bsStyle?: string;
    /** Leading icon; defaults to a plus for Add actions. */
    icon?: any;
    /** Extra classes (e.g. "table-add-button" for absolute positioning). */
    className?: string;
    /** Inline style passthrough (e.g. spacing to match the surrounding layout). */
    style?: any;
}

/**
 * Shared "Add" control: the standard solid-blue button with a leading icon,
 * used for the "Add X" actions across the admin list views. Mirrors the
 * shared ExportToExcelButton precedent so every list view uses one button.
 */
export const AddButton: React.FC<Iprops> = ({
    label,
    onClick,
    disabled,
    bsStyle = 'primary',
    icon = ['far', 'plus'],
    className,
    style
}) => (
    <Button
        bsStyle={bsStyle}
        className={`add-button ${className || ''}`.trim()}
        style={style}
        onClick={onClick}
        disabled={disabled}
    >
        <FontAwesomeIcon icon={icon} style={{ marginRight: 6 }} />
        {label}
    </Button>
);

export default AddButton;
